import react, { useEffect, useState } from 'react';
import Button from './Button';
import { leftArrow, search, rightArrow } from './utils';

function App() {
  const [curMode, setCurMode] = useState('Light');

  const checkMode = () => {
    if (curMode === 'Light') {
      localStorage.setItem('darkMode', 'Dark');
      setCurMode(localStorage.getItem('darkMode'))
    } else {
      localStorage.setItem('darkMode', 'Light');
      setCurMode(localStorage.getItem('darkMode'))
    }
  }

  const handleDarkMode = () => {
    checkMode();
  }

  useEffect(() => {
    setCurMode(localStorage.getItem('darkMode'))
  }, [curMode])

  return (
    <>
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      <h1>Dark Mode</h1>
      <div className={curMode === "Dark" ? "darkMode" : 'lightMode'}>
        <div className='header'>
          {leftArrow}
          <h2>Setting</h2>
          {search}
        </div>
        <ul>
          <li>Language <span>{rightArrow}</span></li>
          <li>Dark Mode <span><Button onHandleDarkMode={handleDarkMode} curMode={curMode} /></span></li>
          <li>Notifications <span>{rightArrow}</span></li>
          <li>Account <span>{rightArrow}</span></li>
          <li>Help <span>{rightArrow}</span></li>
        </ul>
      </div>
    </>
  );
}

export default App;
